/* eslint-disable global-require */
/* eslint-disable no-underscore-dangle */

import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import apiMiddleware from 'middlewares/api';
import routerMiddleware from 'middlewares/router';
import playerMiddleware from 'middlewares/player';
import userMiddleware from 'middlewares/user';
import appMiddleware from 'middlewares/app';
import rootReducers from './reducers';
import sagas from './sagas';
import userAgent from './utils/userAgent';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const sagaMiddleware = createSagaMiddleware();
const store = createStore(
  rootReducers,
  composeEnhancers(
    applyMiddleware(
      sagaMiddleware,
      apiMiddleware,
      routerMiddleware,
      playerMiddleware,
      userMiddleware,
      appMiddleware
    )
  )
);
const setUserAgent = (payload) => store.dispatch({ type: 'APP.SET_UA', payload });
let sagaTask = sagaMiddleware.run(function* runSagas() {
  yield sagas();
});

if (process.env.NODE_ENV !== 'production' && module.hot) {
  // Enable Webpack hot module replacement for reducers
  module.hot.accept('./reducers', () => {
    const nextRootReducer = require('./reducers').default;
    store.replaceReducer(nextRootReducer);
  });
  // Enable Webpack hot module replacement for sagas
  module.hot.accept('./sagas', () => {
    const getNewSagas = require('./sagas');
    sagaTask.cancel();
    sagaTask.done.then(() => {
      sagaTask = sagaMiddleware.run(function* replacedSaga() {
        yield getNewSagas();
      });
    });
  });
}

userAgent().then(setUserAgent);

export default store;
